module.exports = __webpack_public_path__ + "images/124043cc969e6b6df3de29111aa5d6ac.png";